import React from 'react'
import { Alert, Snackbar } from '@mui/material'
import { selectNotification, setNotification } from './uiWidgetsSlice'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'

export interface Notification {
  open: boolean
  severity: 'success' | 'error' | 'warning'
  message: string
}

const GlobalSnackbarNotifier: React.FC = () => {
  const dispatch = useAppDispatch()
  const notification = useAppSelector(selectNotification)

  const handleNotificationClose = (event?: React.SyntheticEvent | Event, reason?: string): void => {
    // you must explicitly click the close button.
    if (reason === 'clickaway') return

    dispatch(setNotification({ ...notification, open: false }))
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={notification.open}
      autoHideDuration={6000}
      onClose={handleNotificationClose}>
      <Alert onClose={handleNotificationClose} severity={notification.severity} sx={{ width: '100%' }}>
        { notification.message }
      </Alert>
    </Snackbar>
  )
}

export default GlobalSnackbarNotifier
